import { render, staticRenderFns } from "./InstagramPreview.vue?vue&type=template&id=6b12cd1f&scoped=true"
import script from "./InstagramPreview.vue?vue&type=script&lang=js"
export * from "./InstagramPreview.vue?vue&type=script&lang=js"
import style0 from "./InstagramPreview.vue?vue&type=style&index=0&id=6b12cd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12cd1f",
  null
  
)

export default component.exports